// @flow
import { deviceTypes } from './devices';

export const activePlugs = `/products/${deviceTypes.ACTIVE_PLUG}/:id`;
export const bulbs = `/products/${deviceTypes.BULB}/:id`;
export const camera = '/camera-hold';
export const changePassword = '/change-password';
export const changePin = '/change-pin';
export const connectedCareInvite = '/accept-hive-link-invite/:token';
export const contactSensor = `/products/${deviceTypes.CONTACT_SENSOR}/:id`;
export const dashboard = '/dashboard';
export const dev = '/dev/:item?';
export const devices = '/devices';
export const forgottenPassword = '/forgotten-password';
export const heating = `/products/${deviceTypes.HEATING}/:id`;
export const help = '/help';
export const holidayMode = '/holiday-mode';
export const hiveButton = `/products/${deviceTypes.HIVE_BUTTON}/:id`;
export const hotwater = `/products/${deviceTypes.HOT_WATER}/:id`;
export const install = '/install';
export const installDevices = '/install/devices';
export const installDevicePlacement = '/install/devices/device-placement';
export const installDevicesInstructions = '/install/devices/instructions';
export const installDevicesFound = '/install/devices/found';
export const installDevicesTroubleshooting = '/install/devices/troubleshooting/:from?';
export const installDevicesTroubleshootingClean = '/install/devices/troubleshooting';
export const installHive2 = '/install/hive2';
export const installHive2InsertBatteries = '/install/hive2/insert-batteries';
export const installHive2RemoveBatteries = '/install/hive2/remove-batteries';
export const installHive2WrongProduct = '/install/hive2/wrong-product';
export const installHub = '/install/hub';
export const installPhilipsHue = '/install/philips-hue/:id';
export const installPhilipsHueSearch = '/install/philips-hue';
export const installMe = '/installme';
export const installSLT3SLT3BUpgrade = '/install/install-slt3-slt3b-upgrade';
export const installSLT3SLT3BAcquireStat = '/install/install-slt3-slt3b-acquire-stat';
export const installSLT3SLT3BUpgradeInsertBatteries = '/install/slt3-slt3b/insert-batteries';
export const installSLT3SLT3BUpgradeRemoveBatteries = '/install/slt3-slt3b/remove-batteries';
export const installSLT3SLT3BUpgradeWrongProduct = '/install/slt3-slt3b/wrong-product';
export const installZones = '/install/zones';
export const installZonesFirmwareUpdate = '/install/zones/firmware-update';
export const installZonesWrongProduct = '/install/zones/wrong-product';
export const leakSensor = `/products/${deviceTypes.LEAK_SENSOR}/:id`;
export const login = '/login';
export const logout = '/logout';
export const manageDevice = '/devices/:id';
export const manageHome = '/home/manage';
export const motionSensor = `/products/${deviceTypes.MOTION_SENSOR}/:id`;
export const myAccount = '/my-account';
export const nathermostat = `/products/${deviceTypes.THERMOSTAT}/:id`;
export const notifications = '/notifications';
export const products = '/products/:productType/:id';
export const readyByFindOutMore = '/ready-by';
export const readyBySetUp = '/ready-by-set-up';
export const recipes = '/actions';
export const resetPassword = '/forgotten-password/:token';
export const resetPasswordCognito = '/reset-password';
export const resetPasswordBiq = '/reset-password-biq';
export const rootPage = '/';
export const sense = '/products/sense/:id';
export const shop = '/shop';
export const sso = '/sso';
export const textControl = '/text-control';
export const upgradeNano1Hub = '/install/install-nano1-upgrade';
export const wiringError = '/wiring-error';
export const wrongProduct = '/wrong-product';
export const mimic = '/mimic-mode';
export const devicesGroups = '/devices?tab=groups';
export const postinstallGroups = '/postinstall/groups';



// WEBPACK FOOTER //
// ./src/core/constants/routes.js